module.exports = __webpack_public_path__ + "media/images/top/top_lg-e11bd8f6af8c4d46ad51db4a4d61a890.jpg";